import makeAction from "./../../libs/actions";

export const login = makeAction("users/LOGIN");
export const getProfile = makeAction("users/GET_PROFILE");
